// import React from "react"
// import {Helmet as ReactHelmet} from "react-helmet"
import PropTypes from "prop-types"
import {Helmet} from "../gatsby-theme-material-ui-top-layout/components"

export default Helmet
